export default {
      id: "ic-play-v2-usage",
      viewBox: "0 0 60 60",
      url: "/" + "images/icons.3.109.2.svg#ic-play-v2-usage",
      toString: function () {
        return this.url;
      }
    }